import DiscountCoupon from '@activities/order/OrderActivity/components/Discount/DiscountCoupon';
import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useModal from '@hooks/ui/useModal';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useDiscounts from './hooks/useDiscounts';
import styles from './styles.module.scss';

function Discount() {
    const discounts = useDiscounts();
    const { orderLines } = useCalculatedRequest();

    const { t } = useTranslation('order');
    const enabledCouponCount = useMemo(() => {
        if (discounts.coupons) {
            const selectedItemIds = orderLines.map((item) => item.shopItemId);
            const filtered = discounts.coupons.filter((coupon) => {
                const { applicableItemIds } = coupon;
                if (applicableItemIds && applicableItemIds.length !== 0) {
                    return selectedItemIds.filter((itemId) => applicableItemIds?.includes(itemId))?.length !== 0;
                }
                return selectedItemIds.length !== 0;
            });
            return filtered.length;
        }
        return 0;
    }, [discounts, orderLines]);
    return (
        <Accordion title={
            <Row spacing={6}>
                <Text size='lg' fontWeight='bold'>{t('discount.title')}</Text>
                <Text className={styles.info}>
                    {t('discount.availableCoupons')} <em>{enabledCouponCount.toLocaleString()}{t('discount.couponUnit')}</em>
                </Text>
                {/*
                <Text className={styles.info}>
                    선물 <em>{discounts?.gifts.length.toLocaleString() || 0}개</em>
                </Text> */}
            </Row>
        }>
            <Column className={styles.container}
                spacing={18}
                fullWidth>
                <Column fullWidth spacing={8}>
                    {(discounts.coupons?.length || 0) > 0 && (
                        <Row align='center'>
                            <Text
                                fontWeight='bold'
                                color={colors.gray7}>
                                {t('discount.couponApply')}
                            </Text>
                            {/* <Info/> */}
                        </Row>
                    )}
                    <Column className={styles.items} fullWidth spacing={12}>
                        {discounts?.coupons?.map(((c) => (
                            <DiscountCoupon coupon={c}
                                key={c.id} />
                        )))}
                    </Column>
                </Column>
                {/*
                <Column fullWidth spacing={8}>
                    <Row align='center'>
                        <Text
                              fontWeight='bold'
                              color={colors.gray7}>
                            선물 적용
                        </Text>
                        <Info/>
                    </Row>
                    <Column className={styles.items} spacing={12} fullWidth>
                        <DiscountItem isChecked={gifts.includes('1')}
                                      onClick={() => toggleGift('1')}
                                      discountAmount={2000}
                                      expiresAt={new Date()}>
                            친구가 준 아메리카노 쿠폰
                        </DiscountItem>
                    </Column>
                </Column>
                */}
            </Column>
        </Accordion>
    );
}

export default Discount;
